var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPromotionsStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7214 0.843656C13.473 0.328088 12.9481 0 12.3716 0C11.7951 0 11.2748 0.328088 11.0217 0.843656L8.008 7.04452L1.2775 8.03816C0.715066 8.12253 0.246368 8.51623 0.0729502 9.05524C-0.100468 9.59424 0.0401412 10.1895 0.443221 10.5879L5.32705 15.4201L4.17405 22.2491C4.08031 22.8115 4.31466 23.3833 4.77867 23.7161C5.24268 24.0489 5.85668 24.0911 6.36287 23.8239L12.3763 20.6133L18.3896 23.8239C18.8958 24.0911 19.5098 24.0536 19.9738 23.7161C20.4379 23.3786 20.6722 22.8115 20.5785 22.2491L19.4208 15.4201L24.3046 10.5879C24.7077 10.1895 24.853 9.59424 24.6749 9.05524C24.4968 8.51623 24.0328 8.12253 23.4703 8.03816L16.7351 7.04452L13.7214 0.843656Z",
    fill: "#007AFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromotionsStar);
export default __webpack_public_path__ + "static/media/promotionsStar.b25558b01b20b423dffbfa1d81732efa.svg";
export { ForwardRef as ReactComponent };